import { Modal, Row, Col } from "antd";
import momentTZ from "moment-timezone";
import React, { Component } from "react";

const RowForm = props => (
  <Row style={{ padding: "5px 10px" }}>{props.children}</Row>
);

class ModalDetail extends Component {
  render() {
    let { priceCheck, toggleModalDetail, showModalDetail } = this.props;
    return priceCheck && priceCheck.id ? (
      <Modal
        title="Detail Cek Harga"
        visible={showModalDetail}
        onOk={() => toggleModalDetail(false)}
        onCancel={() => toggleModalDetail(false)}
        width={700}>
        <p>Detail Cek Harga</p>
        <RowForm>
          <Col span={8}>Nama User</Col>
          <Col span={16}>: {priceCheck.User ? priceCheck.User.name : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Cabang</Col>
          <Col span={16}>: {priceCheck.branch}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Brand Mobil</Col>
          <Col span={16}>: {priceCheck.brand}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Tipe Mobil</Col>
          <Col span={16}>: {priceCheck.type}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Spec Mobil</Col>
          <Col span={16}>: {priceCheck.spec}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Tahun Mobil</Col>
          <Col span={16}>: {priceCheck.year}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Hari / Tanggal Cek Harga</Col>
          <Col span={16}>
            :{" "}
            {momentTZ(priceCheck.createdAt)
              .tz("Asia/Jakarta")
              .format("dddd, D MMMM YYYY HH:mm")}
          </Col>
        </RowForm>
      </Modal>
    ) : null;
  }
}

export default ModalDetail;



// WEBPACK FOOTER //
// src/components/Dashboard/PriceCheckHistory/ModalDetail.js